/**
 * API client tipado para /workspaces/* (WEB-11).
 */

import { api } from "./client";
import type {
  AuditEntry,
  CreateWorkspaceRequest,
  EnvironmentHealth,
  UpdateWorkspaceRequest,
  Workspace,
  WorkspaceMember,
} from "./types";

export async function listWorkspaces(): Promise<Workspace[]> {
  const res = await api.get<Workspace[]>("/workspaces");
  return res.data;
}

export async function getWorkspace(id: string): Promise<Workspace> {
  const res = await api.post<Workspace>("/workspaces/get", { workspace_id: id });
  return res.data;
}

export async function createWorkspace(body: CreateWorkspaceRequest): Promise<Workspace> {
  const res = await api.post<Workspace>("/workspaces", body);
  return res.data;
}

export async function updateWorkspace(
  id: string,
  body: UpdateWorkspaceRequest,
): Promise<Workspace> {
  const res = await api.post<Workspace>("/workspaces/update", { ...body, workspace_id: id });
  return res.data;
}

export async function deleteWorkspace(id: string): Promise<void> {
  await api.post("/workspaces/delete", { workspace_id: id });
}

export async function listWorkspaceMembers(id: string): Promise<WorkspaceMember[]> {
  const res = await api.post<WorkspaceMember[]>("/workspaces/members/list", { workspace_id: id });
  return res.data;
}

export async function addWorkspaceMember(
  id: string,
  body: { user_id: number; role_in_workspace?: "owner" | "member" },
): Promise<WorkspaceMember> {
  const res = await api.post<WorkspaceMember>("/workspaces/members", { ...body, workspace_id: id });
  return res.data;
}

export async function removeWorkspaceMember(id: string, userId: number): Promise<void> {
  await api.post("/workspaces/members/delete", { workspace_id: id, user_id: userId });
}

export async function getWorkspaceAuditLog(
  id: string,
  limit = 200,
): Promise<AuditEntry[]> {
  const res = await api.post<AuditEntry[]>("/workspaces/audit-log", { limit, workspace_id: id });
  return res.data;
}

/** Probe del gateway + oauth2_url del environment activo. ~6s max si ambos timeout. */
export async function getEnvironmentHealth(
  id: string,
): Promise<EnvironmentHealth> {
  const res = await api.post<EnvironmentHealth>("/workspaces/environment-health", { workspace_id: id });
  return res.data;
}
